import { EventEmitter, OnDestroy } from '@angular/core';
export class FPreviewEditorService implements OnDestroy {
    editValueChange = new EventEmitter();
    private uploadPreviewInstance = null;
    constructor() {}
    ngOnDestroy() {
    }
    setInstance(instance){
        this.uploadPreviewInstance=instance;
    }
    /**
     * 获取上下文
     * @param previewIndex 
     * @param colIndex 
     * @returns 
     */
    getPreviewCtx(previewIndex, colIndex) {
        if (this.uploadPreviewInstance) {
            return this.uploadPreviewInstance.getPreviewCtx(previewIndex, colIndex);
        }
        return {};
    }
    /**
     * 获取当前行数据
     * previewIndex实际是附件信息中的第几行
     * @param previewIndex 
     * @returns 
     */
    getRowData(previewIndex) {
        if (this.uploadPreviewInstance) {
            return this.uploadPreviewInstance.getRowData(previewIndex);
        }
        return {};
    }
    /**
     * 获取当前真是数据
     * @param previewIndex 
     * @param field 
     * @returns 
     */
    getRealDataValue(previewIndex,field){
        if (this.uploadPreviewInstance) {
            return this.uploadPreviewInstance.getRealDataValue(previewIndex,field);
        }
        return null;
    }
}